import React from 'react';

import { Image } from 'components/image/Image';
import { asText } from 'components/rich-text/RichText';
import { ImageBlock } from 'components/image-block/ImageBlock';
import { PrismicRichText } from 'types/prismicRichtext';
import { PrismicImage, PrismicImageWithTypes } from 'types/prismicImage';

interface IImageContainer {
  image: PrismicImage | PrismicImageWithTypes;
  caption?: PrismicRichText;
  isColumnLayout?: boolean; // has layout offset styles
  imageOnly?: boolean; // image component only, not
  className?: string;
  setRatio?: boolean; // aspect ratio container
  captionStyle?: 'vertical' | 'horizontal';
  transparent?: boolean;
}

export const ImageContainer = ({
  image,
  caption,
  imageOnly,
  isColumnLayout = false,
  className,
  setRatio,
  captionStyle = 'vertical',
  transparent = false,
}: IImageContainer) => {
  if (!image) {
    return null;
  }

  const { dimensions, alt, url, copyright } = image;
  const { width, height } = dimensions!;

  const renderImage = () => (
    <Image
      width={width}
      height={height}
      alt={alt}
      copyright={copyright}
      url={url}
      caption={caption ? asText(caption) : undefined}
      captionStyle={caption ? captionStyle : undefined}
      className={className}
      imageOnly={imageOnly}
      setRatio={setRatio}
      transparent={transparent}
    />
  );

  if (!isColumnLayout && !imageOnly) {
    return <ImageBlock>{renderImage()}</ImageBlock>;
  }

  return renderImage();
};
